import icon from 'vue-svgicon';

icon.register({
    'regular/login-keys': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12.75 9.807a6 6 0 1 0-7.5 5.811v6.136a1.5 1.5 0 0 0 3 0v-6.136a6 6 0 0 0 4.5-5.811z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M13.563 15.75a5.972 5.972 0 0 0 2.219-.773l4.907 4.906a1.5 1.5 0 0 0 2.121-2.121l-4.91-4.906a6 6 0 0 0-8.159-8.251" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="2" cx="6.75" cy="9.057" r="1.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="3" d="M6.75 7.557V3a2.25 2.25 0 0 1 4.5 0v.989" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
